// extracted by mini-css-extract-plugin
module.exports = {"Button":"Form_Button__2D82Z","Success":"Form_Success__1kvVg","Failed":"Form_Failed__2iavn"};